import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EventData } from '../../data';
import { handleEventos } from '../../api/evento';

const event = {
  title:'Próximos',
  shape_text:'Eventos',
  subtitle:'Confira a agenda dos nossos encontros .'
}

const EventArea = () => {

  const [eventos, setEventos] = useState([]);
 
  useEffect(function() {
    handleEventos().then(function(result) {
      setEventos(result);
    });
  }, []);

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const formattedDateStr = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${(date.getMinutes()<10?'0':'') + date.getMinutes()}`;
    return formattedDateStr;
  }

  return (
    <>
      <section className="events__area pt-115 pb-120 p-relative">
        <div className="events__shape">
          <img className="events-1-shape" src="/assets/img/events/events-shape.png" alt="" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-4 offset-xxl-4">
              <div className="section__title-wrapper mb-60 text-center">
                <h2 className="section__title">{event.title} <span className="yellow-bg yellow-bg-big">{event.shape_text}
                  <img src="/assets/img/shape/yellow-bg.png" alt="" /></span></h2>
                <p>{event.subtitle}</p>
              </div>
            </div>
          </div>
          <div className="row">
            {eventos.map((event, index) => (
              <div key={index} className="col-xxl-10 offset-xxl-1 col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
                <div className="events__item mb-10 hover__active">
                  <div className="events__item-inner d-sm-flex align-items-center justify-content-between white-bg">
                    <div className="events__content">
                      <div className="events__meta">
                        <span>{event.date}</span>
                        <span>{event.time}</span>
                        <span>{event.city}</span>
                      </div>
                      <h3 className="events__title">
                        {event.titulo}
                      </h3>
                      { (event.agendado_em.length > 3) ? <p>{formatDate(event.agendado_em)}</p> : "" }
                    </div>
                    {event.link.length > 3 && 
                    <div className="events__more">
                      <a href={event.link} target="_blank" className="link-btn">
                        Ver mais
                        <i className="far fa-arrow-right"></i>
                        <i className="far fa-arrow-right"></i>
                      </a>
                    </div>
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default EventArea;